import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import apiRequest from '../../functions/api';
import { Typography, Button, Grid, Box } from "@mui/material";
import { useMessage } from '../../context/message-context';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import { useSessionStorage } from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import { FullPageSpinner } from '../lib';
import MessageBox from '../shared/components/MessageBox';

const allDoors = [
  {
    key: "frontdoor",
    name: "Haupteingang"
  },
  {
    key: "backdoor",
    name: "Lager"
  },
]

function DoorBell({ client }) {
  const { t } = useTranslation();
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDoor, setSelectedDoor] = useState("");
  const [selectedDoorName, setSelectedDoorName] = useState("");
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const openDoor = () => {
    setIsLoading(true);
    const headers = {
      'Authorization': 'Bearer ' + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "TUERAP",
      "statement": "OEFFNEN",
      'key': selectedDoor,
    }
    apiRequest('POST', 'daten', payload, headers, openCb, errorCb);
  }
  const openCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      showSuccessMessage(response.data.message);
    } else {
      showErrorMessage(response.data.message);
    }
  }
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."));
  }
  const openMessageBox = (doorkey) => {
    setSelectedDoor(doorkey);
    setSelectedDoorName(allDoors.find((d) => d.key === doorkey)?.name);
    setMessageBoxOpen(true);
  }
  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  }
  const messageBoxResult = (answer) => {
    if (answer === 'YES') {
      openDoor();
    }
    closeMessageBox();
  }
  return (
    <Page>
      <Layout>
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={12}>
          <Box p={2}>
            <Typography variant="h4">{t("Zutrittssteuerung")}</Typography>
            </Box>
            <Box p={2}>
            <Typography variant="h5">{t("Welchen Eingang möchtest du öffnen?")}</Typography>
            </Box>
          </Grid>
          {
            allDoors.map((door) => <Grid item xs={12}>
            <Box p={2}>
              <Button variant="contained" color="primary" fullWidth onClick={() => openMessageBox(door.key)}><Typography variant='h5'>{t(door.name)}</Typography></Button>
            </Box>
          </Grid>)
          }
        </Grid>
      </Layout>
      <MessageBox
        title={t("Hinweis")}
        text={t("Möchstest du die Tür am "+selectedDoorName+" jetzt öffnen?")}
        buttons="YESNO"
        onClose={closeMessageBox}
        open={messageBoxOpen}
        handleResponse={messageBoxResult}
      />
      {isLoading && <FullPageSpinner />}
    </Page>
  );
}
export default DoorBell;
